import React from 'react'
import classNames from 'classnames'

interface DueDateInputProps {
  id?: string
  value?: string
  onClick?: () => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  placeholder?: string
  /** Sizes the input to its value instead of filling the available width. */
  fitContent?: boolean
}

export const DueDateInput = React.forwardRef<HTMLInputElement, DueDateInputProps>(
  ({ id, value, onClick, onChange, disabled, placeholder, fitContent = false }, ref) => (
    <div className={classNames('input-group', { 'w-auto': fitContent })}>
      <span className='input-group-text' role='button' onClick={onClick}>
        <i className='bi bi-calendar3' />
      </span>
      <input
        ref={ref}
        id={id}
        type='text'
        className={classNames('form-control', { 'w-auto': fitContent })}
        size={fitContent ? Math.max(value?.length ?? 0, placeholder?.length ?? 0, 1) : undefined}
        value={value}
        onClick={onClick}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
      />
      <span className='input-group-text' role='button' onClick={onClick}>
        <i className='bi bi-chevron-expand' />
      </span>
    </div>
  ),
)
DueDateInput.displayName = 'DueDateInput'
